import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCapabilities } from '../contexts/CapabilitiesContext';

/**
 * Uma página de um módulo que o ginásio não tem ligado não existe: quem lá chega por um endereço antigo ou um favorito volta ao Início.
 * Enquanto não se sabe (primeira visita, sem resposta ainda) espera, em vez de mandar embora quem tem o módulo.
 */
export default function FeatureRoute({ feature, anyOf, children }) {
  const { ready, isEnabled } = useCapabilities();
  const location = useLocation();

  if (!ready) return <div className="loading"><div className="spinner" /></div>;
  const allowed = anyOf ? anyOf.some((f) => isEnabled(f)) : isEnabled(feature);
  if (!allowed) return <Navigate to={location.pathname.startsWith('/admin') ? '/admin' : '/'} replace state={{ moduleOff: feature || anyOf, from: location.pathname }} />;
  return children;
}
